import { useEffect, useState } from 'react';
import { get } from '../../Utilities';
import { getClientId, getClientUserId } from '../../redux/reducers/clientUserId.reducer';
import { dashboardActions } from '../../redux/actions/dashboard.action';
import { connect } from 'react-redux';
import './UserStats.scss';

const MulyankanDash = (props) => {
  const { clientUserId, setActiveTagsToStore, clientId, history, roleArray = [] } = props;
  const [subjects, setSubjects] = useState([]);
  const [examPapers, setExams] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const isStudent = roleArray.includes(1) && !roleArray.includes(3) && !roleArray.includes(6);

  useEffect(() => {
    get({ client_user_id: clientUserId }, '/getDetailsOfClientBatchMulyankan').then((res) => {
      setIsLoading(false);
      if (res && res.success) {
        setActiveTagsToStore(
          res.result.filter((ele) => ele.tag_category_id == '36').map((ele) => ele.tag_id),
        );
        setSubjects(res.result.filter((ele) => ele.tag_category_id == '16'));
        setExams(res.result.filter((ele) => ele.tag_category_id == '27'));
      }
    });
  }, []);

  //   const examPapers = [
  //     {
  //       id: 1,
  //       title: 'CBSE Boards',
  //       subtitle: 'Song',
  //       image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=400&h=300&fit=crop',
  //       logo: true,
  //     },
  //     {
  //       id: 2,
  //       title: 'Artist',
  //       subtitle: 'Song',
  //       image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
  //     },
  //     {
  //       id: 3,
  //       title: 'Artist',
  //       subtitle: 'Song',
  //       image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=300&fit=crop',
  //     },
  //   ];

  const goToPractice = (subject) => {
    history.push({
      pathname: `/practice`,
      search: `subject_id=${subject.tag_id}`,
      state: [subject.tag_id],
    });
  };

  const goToExamSimulator = (exam) => {
    history.push({ pathname: 'v2/test', state: [exam.tag_id] });
  };

  return (
    <div className='MulyankanDash__container'>
      {/* Create Exam Paper Section */}
      {examPapers.length > 0 && (
        <div className='MulyankanDash__section pt-3'>
          <div className='MulyankanDash__header'>
            <p className='MulyankanDash__title px-3 px-md-0'>Create Exam Paper</p>
          </div>

          <div className='MulyankanDash__scroll-container'>
            <div className='MulyankanDash__cards-wrapper'>
              {examPapers.map((paper) => (
                <div
                  role='button'
                  onClick={() => goToExamSimulator(paper)}
                  key={paper.id}
                  className='MulyankanDash__exam-card ml-3 ml-md-0'
                >
                  <div className='MulyankanDash__card-image-wrapper'>
                    <img
                      src={paper.icon}
                      alt={paper.tag_name}
                      className='MulyankanDash__card-image'
                    />
                    {paper.logo && (
                      <div className='MulyankanDash__logo-overlay'>
                        <div className='MulyankanDash__cbse-logo'>
                          <svg width='80' height='80' viewBox='0 0 80 80' fill='none'>
                            <circle
                              cx='40'
                              cy='40'
                              r='38'
                              fill='#1a3a52'
                              stroke='#d4af37'
                              strokeWidth='2'
                            />
                            <path d='M40 25 L35 30 L40 35 L45 30 Z' fill='#d4af37' />
                            <rect x='35' y='35' width='10' height='15' fill='#d4af37' />
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='MulyankanDash__card-content'>
                    <h3 className='MulyankanDash__card-title'>{paper.tag_name}</h3>
                    <p className='MulyankanDash__card-subtitle'>Exam</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Questions by Subject Section */}
      {isStudent && subjects.length > 0 && (
        <div className='MulyankanDash__section mb-0 pb-3'>
          <div className='MulyankanDash__header'>
            <h2 className='MulyankanDash__title px-3 px-md-0'>Questions by Subject</h2>
            <button className='MulyankanDash__arrow-btn'>
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M9 18l6-6-6-6'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>
          </div>

          <div className='MulyankanDash__subjects-grid mx-3 mx-md-auto'>
            {subjects.map((subject) => (
              <div
                role='button'
                onClick={() => goToPractice(subject)}
                key={subject.tag_id}
                className='MulyankanDash__subject-card'
              >
                <img
                  src={subject.icon}
                  alt={subject.tag_name}
                  className='MulyankanDash__subject-image'
                />
                <div className='MulyankanDash__subject-label'>
                  <span>{subject.tag_name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  clientId: getClientId(state),
  clientUserId: getClientUserId(state),
});

const mapDispatchToProps = (dispatch) => ({
  setActiveTagsToStore: (payload) => {
    dispatch(dashboardActions.setActiveTagsToStore(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MulyankanDash);
